module.exports = __webpack_public_path__ + "login-background.5f29083.png";